import { DOCUMENT } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  Inject,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DocumentService } from 'src/modules/features/contractor/services';

@Component({
  selector: 'app-official-list',
  templateUrl: './official-document-list.component.html',
  styleUrls: ['./official-document-list.component.scss'],
})
export class OfficialListComponent implements OnInit {
  @Input() documents = [];
  @Input() documentTypeId;
  @Input() activeId;
  @Output() uploadDoc: EventEmitter<any> = new EventEmitter();
  @Output() editDoc: EventEmitter<any> = new EventEmitter();
  @Output() onView: EventEmitter<any> = new EventEmitter();
  @Output() history: EventEmitter<any> = new EventEmitter();
  @Output() upload: EventEmitter<any> = new EventEmitter();
  @Output() verificationStatus: EventEmitter<any> = new EventEmitter();
  @Output() removeDocument: EventEmitter<any> = new EventEmitter();
  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() download: EventEmitter<any> = new EventEmitter();
  @Output() onArchive: EventEmitter<any> = new EventEmitter();
  @Output() removeArchive: EventEmitter<any> = new EventEmitter();
  baseUrl = environment.API_SERVER;
  @Input() totalHistory: any;
  @Input() allHistoryData: any;
  @Input() documentStatus;
  @Input() archivedDocu;
  archivedDocuments = [];
  filteredDocuments: any[];
  pending;
  error;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId;
  getVerifiedCount(): number {
    return this.documents?.filter((doc) => doc.status === 'ACTIVE').length || 0;
  }
  getArchivedCount(): number {
    return (
      this.documents?.filter((doc) => doc.status === 'ARCHIVED').length || 0
    );
  }
  getPendingCount(): number {
    return (
      this.documents?.filter((doc) => doc.verificationStatus == 'PENDING')
        .length || 0
    );
  }
  getVerified() {
    return this.documents?.filter(
      (doc) => doc.verificationStatus == 'VERIFIED'
    );
  }
  getPending() {
    return this.documents?.filter((doc) => doc.verificationStatus == 'PENDING');
  }

  constructor(private documentSvc: DocumentService) {
    this.organizationId = window.localStorage.getItem('organizationId');
  }

  collapseDetails: boolean = true;

  ngOnInit(): void {
    if (this.archivedDocu && this.archivedDocu.length > 0) {
      this.archivedDocuments = this.archivedDocu.map(
        (record) => record.value[0]
      );
    }

    // // this.archivedDocuments = this.archivedDocu.map(record => record.value);

    //   this.archivedDocuments = this.archivedDocu.forEach((record)=>{
    //     record.value
    //   })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.activeId === this.documentTypeId) {
      this.getPendingPage(this.activeId);
    }
    if (this.activeId === this.documentTypeId) {
      this.getHistoryPage(this.activeId);
    }
    if (changes.documentStatus || changes.documents) {
      this.filterDocuments();
    }

    if (changes.allHistoryData) {
      // Add any additional processing or initialization here
    }
  }
  returnJSON(data) {
    return JSON.parse(data);
  }
  pendingDocuments;
  getPendingPage(id) {
    this.pending = true;
    this.documentSvc
      .getPendingDocument({
        organizationId: this.organizationId,
        docId: id,
      })
      .subscribe(
        (res: any) => {
          this.pendingDocuments = res;
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.pendingDocuments = null;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  historyDocuments;
  editNow(documentss) {
    let combinedObj = Object.assign({}, documentss, {
      id: this.documentTypeId,
    });
    this.editDoc.emit(combinedObj);
  }
  getHistoryPage(id) {
    this.pending = true;
    this.documentSvc
      .getHistoryDocument({
        organizationId: this.organizationId,
        docId: id,
      })
      .subscribe(
        (res: any) => {
          this.historyDocuments = res.rows;
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  filterDocuments() {
    if (this.documentStatus === 'verified') {
      this.filteredDocuments = this.documents?.filter(
        (doc) => doc.status === 'ACTIVE'
      );
    } else if (this.documentStatus === 'pending') {
      this.filteredDocuments = [this.pendingDocuments];
    } else if (this.documentStatus == 'archive') {
      this.filteredDocuments = this.documents?.filter(
        (doc) => doc.status === 'ARCHIVED'
      );
    } else if (this.documentStatus == 'history') {
      this.filteredDocuments = this.historyDocuments;
    } else {
      this.filteredDocuments = this.documents;
    }
    return this.filteredDocuments;
  }

  toggleTable(item) {
    this.collapseDetails = !this.collapseDetails;
    // this.collapseAppDetails == false;
  }
}
